import {sendGetRequest} from '../requests';
import {CardDescription, SingleCard} from '../../components/dashboard/types';

const baseUrl = '/dashboard/cards';

export const getCardTypes = (): Promise<CardDescription[]> => sendGetRequest(`${baseUrl}/types`);

export const getCards = (params): Promise<SingleCard[]> => sendGetRequest(`${baseUrl}`, params);

export const getCard = (cardType): Promise<SingleCard> => sendGetRequest(`${baseUrl}/${cardType}`);
